import { useState, useEffect } from 'react';
import axios from 'axios';
import UnitOnlyCard from './UnitOnlyCard';
import Header from './Header';
import Footer from './Footer';
import AccessibilityWidget from './AccessibilityWidget';
import { Loader2 } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const parseTonnage = (t) => parseFloat(t) || 0;

export default function UnitOnlyGrid({ onAddToCart, onOpenLeadForm, onOpenEstimateForm, cartItems, onOpenCart }) {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
    axios.get(`${API}/products`).then(r => {
      const sorted = [...r.data].sort((a, b) => parseTonnage(a.tonnage) - parseTonnage(b.tonnage));
      setProducts(sorted);
    }).catch(() => {}).finally(() => setLoading(false));
  }, []);

  return (
    <div className="min-h-screen bg-white" data-testid="unit-only-page">
      <Header onOpenLeadForm={onOpenLeadForm} onOpenEstimateForm={onOpenEstimateForm} cartItems={cartItems} onOpenCart={onOpenCart} />
      <section className="bg-gray-50 py-16">
        <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12">
          <div className="text-center mb-12">
            <span className="inline-block bg-emerald-100 text-emerald-700 text-sm font-semibold px-4 py-1.5 rounded-full mb-4">
              Unit Only
            </span>
            <h1 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-2" data-testid="unit-only-title">
              HVAC Systems - Unit Only
            </h1>
            <p className="text-gray-600 max-w-2xl mx-auto">
              Purchase your Goodman Heat Pump system at our best price. Includes Air Handler, Condenser, and Heating Element. Buy online and save!
            </p>
            <a
              href="https://citiretailservices.citibankonline.com/apply/brandsource-credit-card?app=UNSOL&siteId=PLCN_BRANDSOURCE&sc=06302"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block mt-4 px-8 py-3 rounded-lg transition-colors text-lg"
              style={{ backgroundColor: '#059669', color: '#FACC15', fontWeight: 900 }}
              data-testid="apply-financing-link"
            >
              Apply for Financing
            </a>
          </div>

          {loading ? (
            <div className="flex items-center justify-center py-20">
              <Loader2 className="w-8 h-8 animate-spin text-emerald-600" />
              <span className="ml-3 font-medium text-gray-600">Loading Products...</span>
            </div>
          ) : (
            <>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-testid="unit-only-grid">
                {products.map(p => (
                  <UnitOnlyCard key={p.id} product={p} onAddToCart={onAddToCart} />
                ))}
              </div>
              <p className="text-xs text-gray-400 text-center mt-8">
                *12 months deferred interest W.A.C. Make all payments on time and interest = 0%.
              </p>
            </>
          )}
        </div>
      </section>
      <Footer />
      <AccessibilityWidget />
    </div>
  );
}
